<template>
    <c-dialog ref="dialog" height="350" width="450" @resolve="editHandle">
        <template #head>
            <div class="m-detail-tag flex-center-cross">
                <c-state async tag dict="CHECK_PAYMENT_CHANNEL" :value="check_payment_channel"></c-state>
            </div>
        </template>
        <c-form ref="payForm" unit-width="100%">
            <c-form-item label="提现金额" tip="单次次提现将收取 1元 手续费，单次提现金额不少于1元，最多5万元">
                <c-input name="withdraw_amount" class="m-price-input" type="number" decimal="2" append-text="元" disabled></c-input>
            </c-form-item>
            <c-form-item label="验证码" required :tip="phone?'验证码将发送至手机【'+phone+'】，请向相关人员索要验证码':''">
                <c-input class="flex-grow" type="text" name="verify_code" v-model="verify_code" maxlength="6" :clear="false">
                    <template #append>
                        <a class="smscode" :class="{'z-dis': !!countdown}" @click="getSmscode">{{countdownText}}</a>
                    </template>
                </c-input>
            </c-form-item>
            <c-form-item label="提现银行卡号" required>
                <c-select name="bank_card_id" async @search="searchBankCard"></c-select>
            </c-form-item>
        </c-form>
    </c-dialog>
</template>

<script>

export default {
    name:'cashWithdrawApplyConfirm',
    data() {
        return {
            phone: '',
            verify_code: '',
            countdown: false,
            ids:[],
            withdraw_amount:0,
            check_payment_channel:undefined,
            withdraw_account_type:2        //三方同售账户
        }
    },
    computed: {
        countdownText() {
            return this.countdown ? `(${this.countdown})` : this.countdown === 0 ? '重新获取' : '获取验证码';
        }
    },
    mounted() {
        this.countdown = false;
    },

    methods: {
        /*********打开编辑框，初始化**********/
        open(data) {
            this.check_payment_channel = data.check_payment_channel;
            this.ids = data.ids;
            this.withdraw_amount = data.withdraw_amount;
            this.$refs.payForm.clear();
            this.$refs.payForm.set({
                withdraw_amount:parseFloat(this.withdraw_amount/100).toFixed(2)
            });
            //填充form表单
            this.$refs.dialog.open({
                title: '三方同售账户提现确认'
            });
        },

        /*******搜索已绑定银行卡*****************/
        searchBankCard(keyword, resolve) {
            this.request({
                url: '/sys_saas/bankcard/options',
                data: {
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            })
        },

        //获取验证码
        getSmscode() {
            if (this.countdown) return;
            //调用发送短信接口
            this.request({
                url: '/saas_withdraw/verify/code',
                data: {},
                loading: true,
                success: data => {
                    this.phone = data;
                    this.$message({
                        message: '验证码已发送'
                    });
                    //60秒后可以重新获取
                    !function loop(s) {
                        this.countdown = s;
                        if (s == 0) return;
                        this._timer = setTimeout(() => {
                            loop.call(this, --s);
                        }, 1000);
                    }.call(this, 60);
                }
            });
        },
        /*******提现申请提交处理方法********/
        editHandle(stop, next){
            stop();
            this.$refs.payForm.submit({
                url: '/withdraw/saas/apply',
                rule: {
                    withdraw_amount: [{
                        type: 'empty',
                        message: '请输入提现金额'
                    }, {
                        type: 'function',
                        fun: (value, data) => {
                            return value > 1 && value < 50000;
                        },
                        message: '单次提现金额必须大于1元，小于5万元'
                    }],
                    verify_code: '请输入提现验证码',
                    bank_card_id: '请选择提现银行卡'
                },
                dataFormatter: data => {
                    data.check_payment_channel = this.check_payment_channel;
                    data.withdraw_account_type = this.withdraw_account_type;
                    data.check_order_product_ids = this.ids;
                    return data;
                },
                success: (data, res) => {
                    this.check_payment_channel = 0;
                    //关闭页面
                    this.$refs.dialog.close();
                    next();
                    this.$message({
                        message: '提现申请成功',  // 提示内容,
                        type: 'success'
                    });
                    this.$emit('resolve');
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
.smscode {
    display: block;
    margin-top: 9px;
    margin-right: 8px;
    line-height: 20px;
    font-size: 12px;
    color: var(--color-main);

    &.z-dis {
        color: #999;
    }
}
</style>